import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Header from '../Header';
import { getNewsReview, getPressResume } from '../../../utils/apiMiniWidget';
import PressResume from '../../views/PressResume/PressResume';
import { Resume } from '../../../../assets/images/index';
import { StyledBoxInside, StyledTitleWidget, StyledWrapper } from './style';
import { SearchByDate } from '../../views/SearchByDate';

const defaultTextForNow = 'No existen datos para el día seleccionado.';

class PressResumePage extends Component {
  constructor(props) {
    super(props);
    this.state = { recent: undefined, now: undefined };
    this.dateSelected = undefined;
  }

  componentDidMount() {
    getPressResume(moment().format('YYYY-MM-DD'))
      .then(pressNowData => {
        this.setState({ now: pressNowData });
      })
      .catch(error => {
        console.error('Error desde PressResume', error);
      });
    getNewsReview()
      .then(pressResumeData => {
        this.setState({ recent: pressResumeData });
      })
      .catch(error => {
        console.error('Error desde PressResume', error);
      });
  }

  selectDate = fromDate => () => {
    this.dateSelected = fromDate;
    getPressResume(fromDate)
      .then(pressNowData => {
        this.setState({ now: pressNowData });
      })
      .catch(error => {
        console.error('Error desde PressResume', error);
      });
  };

  clickTitle = () => {
    this.forceUpdate();
    this.componentDidMount();
  };

  render() {
    const { history } = this.props;
    const { recent, now } = this.state;

    moment.locale('es');
    return (
      <div
        className="pressResume_container"
        style={{ backgroundColor: '#FFF' }}
      >
        <Header history={history} />

        <StyledBoxInside>
          <StyledTitleWidget
            title="resumen de prensa"
            type="resumen"
            icon={Resume}
            small
            onClick={this.clickTitle}
          />
          <StyledWrapper>
            <SearchByDate
              day={moment().format('DD')}
              month={moment().format('MMMM')}
              weekday={moment().format('dddd')}
              onClick={this.selectDate}
            />
          </StyledWrapper>
          <StyledWrapper>
            <PressResume
              key="1"
              dataList={now}
              defaultTextForNow={defaultTextForNow}
              title={`Resumen de prensa del ${moment(this.dateSelected).format(
                'DD-MM-YYYY'
              )}`}
            />
          </StyledWrapper>
          <StyledWrapper>
            {recent && recent.length > 0 && (
              <PressResume
                key="2"
                dataList={recent}
                title="Los más recientes"
              />
            )}
          </StyledWrapper>
        </StyledBoxInside>
      </div>
    );
  }
}

PressResumePage.propTypes = {
  author: PropTypes.shape({
    user: PropTypes.shape({ name: PropTypes.string }),
    association: PropTypes.shape({ name: PropTypes.string })
  })
};

export default PressResumePage;
